const rankingNameCollator = new Intl.Collator("es", {
  sensitivity: "base",
  numeric: true
});

function numericValue(value) {
  return Number(value) || 0;
}

function displayName(user) {
  return user?.name || user?.email || user?.uid || user?.id || "";
}

export function compareRankingUsers(a, b) {
  const pointsDelta = numericValue(b?.totalPoints) - numericValue(a?.totalPoints);
  if (pointsDelta) return pointsDelta;

  const exactScoresDelta = numericValue(b?.exactScores) - numericValue(a?.exactScores);
  if (exactScoresDelta) return exactScoresDelta;

  const correctOutcomesDelta = numericValue(b?.correctOutcomes) - numericValue(a?.correctOutcomes);
  if (correctOutcomesDelta) return correctOutcomesDelta;

  return rankingNameCollator.compare(displayName(a), displayName(b));
}

export function rankUsers(users = []) {
  return [...users].sort(compareRankingUsers);
}

export function findUserRank(ranking, uid) {
  if (!uid) return null;
  const index = ranking.findIndex((user) => user.uid === uid || user.id === uid);
  return index >= 0 ? index + 1 : null;
}
